<Panel maxw="58rem" px="md" py="md" bg="light-" rounded="xs" border-bottom="2px solid white">

  <Panel flex items="start" line="double">

    <div class:hidden={!expanded}>
      <Panel grow line="normal">
        <Heading lg bold color="black">{title}</Heading>
        <Text sm color="body">
          {@html description}
        </Text>
      </Panel>
    </div>
      
    <div class:hidden={expanded}>
      <Panel>
        <slot name="resume"></slot>
      </Panel>
    </div>
    
    <Icon 
      name={expanded ? "collapse" : "expand"}
      color="primary" hover pointer size="1.75" 
      bg="surface" rounded="sm"
      on:click={() => expanded = !expanded }
      />
  </Panel>

  {#if expanded}
    <div 
      transition:slide="{{delay: 20, duration: 150}}">
      <slot name="content"></slot>
    </div>
  {/if}

</Panel>

<style>
  .hidden {
    display: none;
  }
</style>

<script>
  import { fade, slide } from "svelte/transition";
  import { Panel, Input, Select, Heading, Label, Text, Icon } from 'svelte-stylo';

  export let 
    expanded = true,
    title = '',
    description = '';

</script>